import SearchChips from 'components/SearchChips/SearchChips';
import SectionHeader from 'components/SectionHeader/SectionHeader';
import SelectTimePeriod from 'components/SearchInputs/SelectTimePeriod';
import SelectUmpireLeagues from 'components/SearchInputs/SelectUmpireLeagues';
import SelectUmpireSession from 'components/SearchInputs/SelectUmpireSession';
import SelectUmpires from 'components/SearchInputs/SelectUmpires';
import { useReportId } from 'hooks/helperHooks';
import { useTranslation } from 'react-i18next';
import useUmpireSingleSessionReport from 'hooks/UmpireReport/SingleSession/useUmpireSingleSessionReport';

type Props = {
  isSearchCriteriaOpen: boolean;
  setSearchCriteriaOpen: () => void;
};

const SingleSessionSearchCriteria = ({ isSearchCriteriaOpen, setSearchCriteriaOpen }: Props) => {
  const { isCreate } = useReportId();

  const { searchCriteria, setSearchCriteria, searchChips } = useUmpireSingleSessionReport();

  const { t } = useTranslation();

  return (
    <>
      <SectionHeader
        isOpen={isSearchCriteriaOpen}
        onClick={isCreate ? setSearchCriteriaOpen : undefined}
        title={t('Populate report')}
        isEnabled={isCreate}
      />
      {isSearchCriteriaOpen ? (
        <div className='report-layout-shelf-section'>
          <SelectTimePeriod
            selectedSeasonNames={searchCriteria.seasonNames}
            onChange={(seasonNames, dateRanges) =>
              setSearchCriteria({
                dateRanges,
                seasonNames,
                leagues: undefined,
                umpires: undefined,
                session: undefined,
              })
            }
          />
          <SelectUmpireLeagues
            selectedLeagues={searchCriteria.leagues}
            onChange={(leagues) => setSearchCriteria({ leagues, umpires: undefined, session: undefined })}
            dateRanges={searchCriteria.dateRanges}
          />
          <SelectUmpires
            selectedUmpires={searchCriteria.umpires}
            onChange={(umpires) => setSearchCriteria({ umpires, session: undefined })}
            dateRanges={searchCriteria.dateRanges}
            leagueIds={searchCriteria.leagues?.map((league) => league.id)}
          />
          <SelectUmpireSession
            selectedSession={searchCriteria.session}
            onChange={(session) => setSearchCriteria({ session })}
            dateRanges={searchCriteria.dateRanges}
            leagueIds={searchCriteria.leagues?.map((league) => league.id)}
            umpireIds={searchCriteria.umpires?.map((umpire) => umpire.id)}
          />
        </div>
      ) : (
        searchChips.dateRanges && (
          <SearchChips
            seasonNames={searchChips.seasonNames}
            dateRanges={searchChips.dateRanges}
            otherChips={{ ...searchChips, dateRanges: undefined, seasonNames: undefined }}
          />
        )
      )}
    </>
  );
};

export default SingleSessionSearchCriteria;
